export default __webpack_public_path__ + "static/media/check.3f85bbf0.svg";